import { gql } from "@apollo/client"

export const QUERY_DEMATCHING_SHOPS = gql`
    query dematchingShops {
        dematchingShops {
            id
            name
            lang
            matchedCount
        }
    }
`

export const QUERY_DEMATCHING_COVERAGE_OVERVIEW = gql`
    query dematchingCoverageOverview($shopId: Long!) {
        dematchingCoverageOverview(shopId: $shopId) {
            customerAssortment {
                matchedCount
                totalCount
                coveragePercent
            }
            shopCoverages {
                id
                name
                lang
                matchedCount
                totalProductCount
                coveragePercent
                colorHex
            }
        }
    }
`

export const QUERY_DEMATCHING_PRODUCER_COVERAGE_STATS = gql`
    query dematchingProducerCoverageStats($shopId: Long!) {
        dematchingProducerCoverageStats(shopId: $shopId) {
            categoryCoverages {
                id
                name
                matchedCount
                totalCount
                coveragePercent
            }
            producerCoverages {
                id
                name
                matchedCount
                totalCount
                coveragePercent
            }
        }
    }
`

export const QUERY_DEMATCHING_COVERAGE_STATS = gql`
    query dematchingCoverageStats($shopId: Long!) {
        dematchingCoverageStats(shopId: $shopId) {
            customerAssortment {
                matchedCount
                totalCount
                coveragePercent
            }
            shopCoverages {
                id
                name
                lang
                matchedCount
                totalProductCount
                coveragePercent
                colorHex
            }
            producerCoverages {
                id
                name
                matchedCount
                totalCount
                coveragePercent
            }
            largestAssortmentProducers {
                id
                name
                matchedCount
                totalCount
                coveragePercent
            }
        }
    }
`

export const QUERY_DEMATCHING_CATEGORIES = gql`
    query dematchingCategories($shopId: Long!) {
        dematchingCategories(shopId: $shopId) {
            id
            name
            count
        }
    }
`

export const QUERY_DEMATCHING_PRODUCERS = gql`
    query dematchingProducers($shopId: Long!) {
        dematchingProducers(shopId: $shopId) {
            id
            name
            count
        }
    }
`

export const QUERY_DEMATCHING_PAIRS = gql`
    query dematchingPairs($filter: DematchingFilterInput!, $offset: Int!, $limit: Int!, $includeTotalCount: Boolean!) {
        dematchingPairs(filter: $filter, offset: $offset, limit: $limit, includeTotalCount: $includeTotalCount) {
            totalCount
            pairs {
                mappingId
                shopId
                linked
                priceTableJsonInfo
                customerProduct {
                    matchId
                    productNr
                    name
                    producer
                    price
                    imageUrl
                    productUrl
                    extArtnr
                }
                foreignProduct {
                    matchId
                    productNr
                    name
                    producer
                    price
                    imageUrl
                    productUrl
                    extArtnr
                }
            }
        }
    }
`

export const MUTATION_DEMATCH_PAIR = gql`
    mutation dematchPair(
        $shopId: Long!
        $foreignProductNr: String!
        $customerProductNr: String!
        $priceTableJsonInfo: String
    ) {
        dematchPair(
            shopId: $shopId
            foreignProductNr: $foreignProductNr
            customerProductNr: $customerProductNr
            priceTableJsonInfo: $priceTableJsonInfo
        ) {
            success
            linked
            affectedShopIds
        }
    }
`

export const MUTATION_REMATCH_PAIR = gql`
    mutation rematchPair(
        $shopId: Long!
        $foreignProductNr: String!
        $customerProductNr: String!
        $priceTableJsonInfo: String
        $affectedShopIds: [Long!]
    ) {
        rematchPair(
            shopId: $shopId
            foreignProductNr: $foreignProductNr
            customerProductNr: $customerProductNr
            priceTableJsonInfo: $priceTableJsonInfo
            affectedShopIds: $affectedShopIds
        ) {
            success
            linked
            affectedShopIds
        }
    }
`
